<template>
  <div class="search-box" style="display: inline-block">
    <input
      class="search-input"
      :placeholder="placeholder"
      type="text"
      v-model="searchString"
      @keydown.enter="searchDelay(false)"
    />
    <span class="search-btn" style="position: relative; overflow: hidden">
      <span
        class="search-btn-mask"
        style="position: absolute; opacity: 0.1; background: #0078d4; left: 0"
        :style="{ top: top + 'px' }"
      ></span>
      <span class="iconfont iconsearch" />
    </span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'ScSearch',
  props: {
    modelData: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    delay: {
      type: Number,
      default: 1000,
    },
  },
  setup() {
    return {
      delayHandle: undefined as number | undefined,
      inAnimation: false,
      changeTime: 0,
    };
  },
  data() {
    return {
      searchString: '',
      top: 35,
    };
  },
  watch: {
    searchString: 'searchDelay',
  },
  mounted() {
    this.searchString = this.modelData;
  },
  methods: {
    searchDelay(delay: boolean) {
      clearTimeout(this.delayHandle);
      this.delayHandle = undefined;
      if (delay && this.delay) {
        this.changeTime = Date.now();
        this.delayHandle = setTimeout(() => {
          this.delayHandle = undefined;
          this.$emit('update:modelData', this.searchString);
        }, this.delay);
        this.startAnimation();
      } else {
        this.$emit('update:modelData', this.searchString);
      }
    },

    startAnimation() {
      if (!this.inAnimation) {
        this.inAnimation = true;
        this.animation();
      }
    },

    animation() {
      requestAnimationFrame(() => {
        if (this.delayHandle !== undefined) {
          this.top = (1 - (Date.now() - this.changeTime) / this.delay) * 35;
          this.animation();
        } else {
          this.top = 35;
          this.inAnimation = false;
        }
      });
    },
  },
});
</script>

<style scoped lang="scss">
.search-box {
  $height: 35px;
  border-radius: $border-radius-medium;
  overflow: hidden;
  display: inline-block;

  .search-input {
    outline: none;
    padding: 0 10px;
    height: $height;
    width: 200px;
    border: 1px solid $color-content-border-primary;

    &::placeholder {
      color: $color-content-text-placeholder;
    }
  }

  .search-btn,
  .search-btn-mask {
    display: inline-block;
    height: $height;
    line-height: $height;
    width: 40px;
    text-align: center;
    border: 1px solid $color-content-border-primary;
    border-left: none;
    vertical-align: bottom;
    background-color: $color-content-bg-primary;
    font-size: $font-size;
    cursor: pointer;
  }
}
</style>
